<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Yarn_Requisitions_Title' | translateWF: 'Yarn Requisitions' }}</h1>
        @if (canEdit()) {
          <div class="page__title_buttons">
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToLotDetail()" />
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <!-- Data Table Panel -->
      <p-panel [header]="'Yarn_Requisitions' | translateWF: 'Yarn Requisitions'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="requisitions()" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'Yarn_Requisitions_Number' | translateWF: 'Requisition Number' }}</th>
                <th>{{ 'Knitting_Order' | translateWF: 'Knitting Order' }}</th>
                <th>{{ 'Requisition_Type' | translateWF: 'Requisition Type' }}</th>
                <th>{{ 'Yarn_Requisitions_Status' | translateWF: 'Status' }}</th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let requisition = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToLotDetail(requisition.id)">
                <td>
                  <a>{{ requisition.requisitionNumber }}</a>
                </td>
                <td>{{ requisition?.initiatorNumber }}</td>
                <td>{{ requisitionType()[requisition.type] }}</td>
                <td>{{ requisitionStatus()[requisition.status] }}</td>
                <td>{{ getItemsInRequisition(requisition) }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">
                  {{ 'Yarn_Requisitions_Not_Found' | translateWF: 'No Requisitions Found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [first]="(currentPage - 1) * pageSize"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            class="mt-4"
          ></p-paginator>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
